/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { DomInjectorService } from '../../../shared/services/domInjector.service.js';

@Component({
  selector: 'get-started',
  template: require('./get-started.component.html'),
})
export class GetStartedComponent extends BaseRoute {
  constructor(injector: Injector, domInjector: DomInjectorService) {
    super(injector);
    this.domInjector = domInjector;
    this.isProspect = true;
    this.isLoading = false;
  }

  generateReplayObject() {
    const objURL = {};
    window.location.search.replace(
      new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
      (a, b, c, d) => {
        objURL[b] = d;
      }
    );
    const promo = this.flowManager.promoCode;
    const appType = this.flowManager.getAppType();
    // On localhost, relay directly back to the local origin so SSO returns here instead of the QA server.
    const isLocalhost = window.location.hostname === 'localhost';
    const replayUrl = isLocalhost
      ? `${document.location.origin}${document.location.pathname}`
      : `${this.flowManager.configObj.allyBaseUrl}/sso/ola/ola?olats=true`;
    const replayObject = {
      Verb: 'GET',
      Url: `${replayUrl}&app=${appType || 'tks'}`,
    };
    if (promo) {
      replayObject.Url = `${replayObject.Url}&promo=${promo}`;
    }
    if (objURL.mbsy !== undefined) {
      // RAF
      replayObject.Url = `${replayObject.Url}&mbsy=${objURL.mbsy}&campaignid=${objURL.campaignid}&mbsy_source=${objURL.mbsy_source}`;
    }
    return replayObject;
  }

  changeIsProspect(bool) {
    this.isProspect = bool;
    this.flowManager.pageError = { hasErrors: false, errorCount: 0 };
  }

  btnClick(e) {
    if (e.action === 'next') {
      this.flowManager.logContactInfo();
    }

    this.handleClick(e.action);
  }

  goToLoginPage() {
    const replayObject = this.generateReplayObject();
    const delimiter = replayObject.Url.includes('?') ? '&' : '?';
    const finalURL = `${replayObject.Url}${delimiter}sso=true`;
    window.location = finalURL;
  }
}
